import http from '../_http'

const policy = {
  //default
  listPolicy: (m) => { return http.post(`manager/wmds/policy/list`, m); },
  detailPolicy: (m) => { return http.get(`manager/wmds/policy/${m.id}`); },

  //crud
  insertPolicy: (m) => { return http.post(`manager/wmds/policy`, m); },
  updatePolicy: (m) => { return http.put(`manager/wmds/policy`, m); },
  deletePolicy: (m) => { return http.delete(`manager/wmds/policy/${m.id}`); },

  //page
  pagePolicy: (m) => { return http.get(`manager/wmds/policy/page`, m); },
}

export default policy

export { policy }